import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, HStack, Text } from '@gluestack-ui/themed';

import { useChartTheme } from './useChartTheme';

/**
 * Feedback helpfulness chart legend (stacked bars + vote-rate line).
 */
export function HelpfulnessChartLegend() {
  const { t } = useTranslation();
  const theme = useChartTheme();

  return (
    <HStack space="md" alignItems="center" mt="$1" testID="helpfulness-chart-legend">
      <HStack space="xs" alignItems="center">
        <Box width={10} height={10} borderRadius="$xs" bg={theme.helpful} />
        <Text size="xs" color="$textSubtle">
          {t('admin.analytics.feedbackHelpfulness.legendHelpful')}
        </Text>
      </HStack>
      <HStack space="xs" alignItems="center">
        <Box width={10} height={10} borderRadius="$xs" bg={theme.notHelpful} />
        <Text size="xs" color="$textSubtle">
          {t('admin.analytics.feedbackHelpfulness.legendNotHelpful')}
        </Text>
      </HStack>
      <HStack space="xs" alignItems="center">
        <Box
          width={20}
          height={0}
          borderTopWidth={2}
          sx={{ _web: { borderTopColor: theme.series } }}
          borderTopColor={theme.series}
        />
        <Text size="xs" color="$textSubtle">
          {t('admin.analytics.feedbackHelpfulness.legendVoteRate')}
        </Text>
      </HStack>
    </HStack>
  );
}
